import { render, staticRenderFns } from "./banner_clients.vue?vue&type=template&id=4a4662de&scoped=true&"
import script from "./banner_clients.vue?vue&type=script&lang=js&"
export * from "./banner_clients.vue?vue&type=script&lang=js&"
import style0 from "./banner_clients.vue?vue&type=style&index=0&id=4a4662de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4662de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4662de')) {
      api.createRecord('4a4662de', component.options)
    } else {
      api.reload('4a4662de', component.options)
    }
    module.hot.accept("./banner_clients.vue?vue&type=template&id=4a4662de&scoped=true&", function () {
      api.rerender('4a4662de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/banner_clients.vue"
export default component.exports